import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { KeyboardTimePicker } from "@material-ui/pickers";
import { ParsableDate } from "@material-ui/pickers/constants/prop-types";
import { useTranslation } from "Providers/TranslationProvider";
import React from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { useFieldControl } from "./FieldHelper";

export default function TimePickerField<T extends FieldValues>(props: {
	label: string;
	name: string;
	control: Control<T>;
	disabled?: boolean;
	children?: JSX.Element[];
}) {
	const { t } = useTranslation();
	const { error, value } = useFieldControl<ParsableDate>(
		props.control,
		props.name
	);

	return (
		<Controller
			as={KeyboardTimePicker}
			control={props.control}
			name={props.name}
			value={value}
			error={!!error}
			helperText={error?.message}
			label={props.label}
			disabled={props.disabled}
			ampm={false}
			keyboardIcon={<CalendarTodayIcon />}
			inputVariant="outlined"
			cancelLabel={t("Common_Dialog_Close")}
			okLabel={t("Common_Dialog_Done")}
			format={t("Common_Format_Time")}
			margin="normal"
			autoOk
			fullWidth
		/>
	);
}
